"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _colors = _interopRequireDefault(require("../../colors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var drawerWidthOpen = 240;
var drawerWidthClosed = 64;
var topbarHeight = 64;
var padding = 20;

var styles = function styles(theme) {
  return {
    topbar: {
      position: 'fixed',
      top: 0,
      width: '100%',
      height: topbarHeight,
      backgroundColor: _colors["default"].white,
      boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.04)'
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      paddingLeft: padding,
      paddingRight: padding,
      transition: theme.transitions.create('margin-left', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    sidebarOpen: {
      marginLeft: drawerWidthOpen
    },
    sidebarClosed: {
      marginLeft: drawerWidthClosed
    }
  };
};

exports.styles = styles;